module.exports = __webpack_public_path__ + "static/media/maintenance.e8c673b2.png";